import { numberHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';

import { NetSuiteJournalEntryLineExpanded } from '../../data/types';
import { setCurrencyPrecision } from '../amounts/amounts';

export const checkJournalEntryLineIsEmpty = (itemLine: domain.NetSuiteJournalEntryLine) =>
    !(
        itemLine.account ||
        numberHelpers.isNumber(itemLine.debitAmount) ||
        numberHelpers.isNumber(itemLine.creditAmount) ||
        itemLine.taxCode ||
        numberHelpers.isNumber(itemLine.taxRate) ||
        numberHelpers.isNumber(itemLine.taxAmount) ||
        numberHelpers.isNumber(itemLine.grossAmount) ||
        itemLine.taxAccount ||
        itemLine.memo ||
        itemLine.department ||
        itemLine.class ||
        itemLine.location ||
        itemLine.customer ||
        itemLine.amortizationSchedule ||
        itemLine.amortizationStartDate ||
        itemLine.amortizationEndDate ||
        itemLine.amortizationResidual
    );

export const setJournalEntryLineCurrencyPrecision = (
    line: NetSuiteJournalEntryLineExpanded,
    currencyPrecision: number
) => ({
    ...line,
    debitAmount: setCurrencyPrecision(line.debitAmount, currencyPrecision),
    creditAmount: setCurrencyPrecision(line.creditAmount, currencyPrecision),
    taxAmount: setCurrencyPrecision(line.taxAmount, currencyPrecision),
    grossAmount: setCurrencyPrecision(line.grossAmount, currencyPrecision),
});
